import {StackScreenProps} from '@react-navigation/stack';
import {Box, Button} from 'native-base';
import React from 'react';
import {Linking, RefreshControl, ScrollView} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {t} from 'react-native-tailwindcss';
import {useTransactionQuery} from '../api/generated';
import {Copiable} from '../components/Copiable';
import {Loader} from '../components/Loader';
import {PropertyCardList} from '../components/PropertyList';
import {useAsyncAction} from '../hooks/useAsyncAction';
import {useUserContext} from '../lib/authContext';
import {formatIntAmount, formatPhone} from '../lib/formatters';
import i18n from '../lib/i18n';
import moment from '../lib/moment';
import {truncateHash} from '../lib/utils';
import {config} from '../stage.config';
import {Nav, NavParams} from './navigation';

export const PaymentScreen: React.FC<StackScreenProps<NavParams, Nav.PaymentScreen>> = ({
  route
}) => {
  const {paymentId} = route.params;
  const {ethAddress} = useUserContext();
  const {data, loading, refetch} = useTransactionQuery({variables: {id: paymentId}});
  const payment = data?.transaction;
  const [onRefresh, isRefreshing] = useAsyncAction(refetch);

  if (loading || !payment) return <Loader active />;
  const isIncome = payment.toAddress === ethAddress;
  const formattedAmount = formatIntAmount(payment.amount);
  const hash = payment.replacementId || payment.id;

  const properties = [
    {label: i18n.t('amount'), value: `${isIncome ? '' : '-'}${formattedAmount}`},
    {label: i18n.t('message'), value: payment.message},
    {
      label: i18n.t(isIncome ? 'fromPhoneNumber' : 'toPhoneNumber'),
      value: formatPhone(isIncome ? payment.fromPhoneNumber : payment.toPhoneNumber, null, true)
    },
    {label: i18n.t('createdAt'), value: moment(payment.createdAt, 'x').format('lll')},
    {label: i18n.t('status'), value: i18n.t(payment.status)},
    {
      label: i18n.t('transactionId'),
      value: <Copiable value={payment.id}>{truncateHash(hash)}</Copiable>
    }
  ];

  return (
    <SafeAreaView style={[t.flex1, t.bgWhite]} edges={['bottom']}>
      <ScrollView
        refreshControl={<RefreshControl refreshing={isRefreshing} onRefresh={onRefresh} />}>
        <Box style={t.mX2}>
          <PropertyCardList properties={properties} />
        </Box>
      </ScrollView>
      <Box style={[t.p4]}>
        <Button onPress={() => Linking.openURL(`${config.explorerUrl}/tx/${hash}`)}>
          {i18n.t('showDetails')}
        </Button>
      </Box>
    </SafeAreaView>
  );
};
